/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_License_Bullet_UpdatesInputs */

const en_marketing_license_bullet_updates = /** @type {(inputs: Marketing_License_Bullet_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A year of updates from the changelog`)
};

const es_marketing_license_bullet_updates = /** @type {(inputs: Marketing_License_Bullet_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un año de actualizaciones del registro de cambios`)
};

const fr_marketing_license_bullet_updates = /** @type {(inputs: Marketing_License_Bullet_UpdatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un an de mises à jour du journal des modifications`)
};

/**
* | output |
* | --- |
* | "A year of updates from the changelog" |
*
* @param {Marketing_License_Bullet_UpdatesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_license_bullet_updates = /** @type {((inputs?: Marketing_License_Bullet_UpdatesInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_License_Bullet_UpdatesInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_license_bullet_updates(inputs)
	if (locale === "es") return es_marketing_license_bullet_updates(inputs)
	return fr_marketing_license_bullet_updates(inputs)
});